import React from 'react';

import { Box, SvgIconProps } from '@mui/material';
import BaseVerifiedIcon from '@mui/icons-material/Verified';

import { colors } from '../constants/colors';

const classes = {
  root: {
    display: 'flex',
    padding: '15px 8px',
    backgroundColor: colors.myta_10,
    borderRadius: 2,
  },
  icon: {
    color: colors.myta,
    flexShrink: 0,
    width: 50,
    height: 36,
  },
};

export const VerifiedIcon = (props: SvgIconProps) => (
  <Box sx={classes.root}>
    <BaseVerifiedIcon sx={classes.icon} {...props} />
  </Box>
);
